import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=387ff3cc&"
import script from "./DetailPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387ff3cc')) {
      api.createRecord('387ff3cc', component.options)
    } else {
      api.reload('387ff3cc', component.options)
    }
    module.hot.accept("./DetailPage.vue?vue&type=template&id=387ff3cc&", function () {
      api.rerender('387ff3cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/goods-receipt-checklist/DetailPage.vue"
export default component.exports